<template lang="html">
  <div class="administration">
    <div class="administration--info" v-if="$route.fullPath==='/administration'">
      <v-row justify=center>
        <v-col cols="12" md="6">
          <h2>Üdvözöllek, {{administratorName}} !</h2>
          <h5 class="caption">
            Ez az oldal csak bejelentkezett felhasználók számára érhető el.
            Kérlek jelentkezz ki, ha befejezted a munkád!
          </h5>
        </v-col>
      </v-row>
      <v-row justify=center>
        <v-col cols="12" md="6">
          <h3>Jogosultságaid</h3>
          <h5>Új védenc oldalának létrehozása: {{permUj ? 'igen' : 'nem'}}</h5>
          <h5>Védenc meglévő oldalának módosítása: {{permMod ? 'igen' : 'nem'}}</h5>
          <h5>Védenc törlése: {{permDel ? 'igen': 'nem'}}</h5>
          <br/>
          <h5>Új hír/esemény létrehozása: {{permUjNews ? 'igen' : 'nem'}}</h5>
          <h5>Hír/esemény módosítása: {{permModNews ? 'igen' : 'nem'}}</h5>

        </v-col>
      </v-row>

      <v-row justify=center v-if="permUj">
        <v-col cols="12" md="6" class="text-center">
          <v-btn class="primary" to='/administration/new'>
              <v-icon>
                mdi-plus
              </v-icon>
                Új védenc
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify=center v-if="permUjNews">
        <v-col cols="12" md="6" class="text-center">
          <v-btn class="primary" to='/administration/createnews'>
              <v-icon>
                mdi-plus
              </v-icon>
                Új hír vagy esemény
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify=center v-if="permMod">
        <v-col cols="12" md="6" class="text-center">
          <p>
            A védenc módosítása<span v-if="permDel">, esetleg törlése</span>
            a védenc egyedi oldaláról kezdeményezhető.<br/>
          </p>
        </v-col>
      </v-row>

      <v-row justify=center v-if="permModNews">
        <v-col cols="12" md="6" class="text-center">
          <p>
            Az események/hírek módosítása a <router-link to="/hirek">Hírek</router-link> oldalról kezdeményezhető.<br/>
          </p>
        </v-col>
      </v-row>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data(){
    return{
      isAuthenticated: this.$store.getters.isAuthenticated,
    }
  },
  computed:{
    administratorName(){
      return this.$store.getters.username;
    },
    permUj(){
       return this.$store.getters.hasPermissionToAddNew
    },
    permMod(){
      return this.$store.getters.hasPermissionToChange
    },
    permDel(){
     return this.$store.getters.hasPermissionToDelete
   },
   permUjNews(){
      return this.$store.getters.hasPermissionToAddNewNewsitem
   },
   permModNews(){
      return this.$store.getters.hasPermissionToChangeNewsitem
   },

  },
}
</script>

<style lang="scss" scoped>
h1, h2, h3, h4,h5{
  text-align: center;
}
</style>
